var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"u-text-h3-s u-font-normal u-inline-block u-align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }